module.exports = __webpack_public_path__ + "static/media/powered-by-relish.215b8b2b.png";